import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { NameSurnameFunction } from './name-surname-function';

const regex = /^[a-zA-Z\u00C0-\u024F'\-]{2,} [a-zA-Z\u00C0-\u024F '\-]{2,}$/;

export const NameSurnameValidator: ValidatorFn = (control: AbstractControl): ValidationErrors => NameSurnameFunction(regex, control);
